import React, { PureComponent } from 'react'
import { crypto } from '@binance-chain/javascript-sdk'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Big from 'big.js'
import { BuyWithMoonPay } from '@binance-chain/honeycomb'

import { setFingerPrint } from 'utils/fingerPrint'
import { Consumer as BNCClientConsumer } from 'containers/context/BNCClientProvider'
import { Consumer as WalletConnectClientConsumer } from 'containers/context/WalletConnectProvider'
import FormInput from 'components/exchange/Input'
import Notifycation from 'components/common/Notifycation'
import FontNumber from 'components/common/FontNumber'

import { setOpenOrder } from 'redux/order/action'
import {
  setNotLoginNotify,
  setTriggerElement,
  setLoading,
  setShowIpValidation,
} from 'redux/global/action'
import { setNeedAuth } from 'redux/account/action'
import { setWalletConnectURI } from 'redux/walletConnect/action'
import { setPriceCheckText, setShowPriceNotify, setPriceCheck } from 'redux/exchange/action'
import request from 'utils/httpRequest'
import { floor, decimalPlaces, toNonExponential } from 'utils/number'
import hasPrivateKey, { isUnlockWithWalletConnect } from 'utils/account'
import { withI18n } from 'i18n/util'
import isElectron from 'utils/isElectron'

import {
  Wrapper,
  Header,
  Space,
  Title,
  BuyButtonContainer,
  Content,
  FormRow,
  FormCol,
  Best,
  Percentage,
  BuyButton,
  SellButton,
  ErrMsg,
  PercentageItem,
} from './styled'

class PlaceOrder extends PureComponent {
  static propTypes = {
    privateKey: PropTypes.string,
    address: PropTypes.string,
    quoteAsset: PropTypes.string,
    baseAsset: PropTypes.string,
    displayBaseAsset: PropTypes.string.isRequired,
    displayQuoteAsset: PropTypes.string.isRequired,
    tickerSize: PropTypes.string,
    lotSize: PropTypes.string,
    orderBooks: PropTypes.object,
    openOrders: PropTypes.array,
    latestTrade: PropTypes.object,
    userInfo: PropTypes.object,
    dispatch: PropTypes.func,
    currentPrice: PropTypes.string,
    buyAmount: PropTypes.string,
    sellAmount: PropTypes.string,
    cipherPassword: PropTypes.string,
    history: PropTypes.object,
    isIpValid: PropTypes.bool,
    formatI18nText: PropTypes.func,
    deviceInfo: PropTypes.object,
    maxBuyAmount: PropTypes.number.isRequired,
    maxSellAmount: PropTypes.number.isRequired,
    hasPriceChecked: PropTypes.number.isRequired,
  }

  static defaultProps = {
    privateKey: '',
    address: '',
    quoteAsset: '',
    baseAsset: '',
    currentPrice: '',
    buyAmount: '',
    sellAmount: '',
    cipherPassword: '',
    orderBooks: {},
    openOrders: [],
    latestTrade: {},
    userInfo: {},
    tickerSize: '0.00000001',
    lotSize: '0.00000001',
    dispatch: () => {},
    history: {},
    isIpValid: true,
    formatI18nText: () => {},
    deviceInfo: {},
  }

  constructor(props) {
    super(props)
    this.state = {
      askValue: '',
      bidValue: '',
      askTotal: '',
      bidTotal: '',
      buyAmount: '',
      sellAmount: '',
      maxSellAmount: '--',
      maxBuyAmount: '--',
      notifyType: '',
      notifyTitle: '',
      notifyMsg: '',
      showNotify: false,
      buyErrMsg: '',
      sellErrMsg: '',
    }
  }

  componentDidUpdate(prevProps) {
    const {
      latestTrade,
      tickerSize,
      lotSize,
      buyAmount,
      sellAmount,
      currentPrice,
      quoteAsset,
      baseAsset,
    } = this.props

    const { askValue, bidValue } = this.state
    const latestTradeP = latestTrade.p || latestTrade.price
    const latestTradePair = latestTrade.s || latestTrade.symbol
    const prevLatestTradePair = prevProps.latestTrade.s || prevProps.latestTrade.symbol

    const ts = decimalPlaces(tickerSize)
    const latestPrice = currentPrice || parseFloat(floor(latestTradeP, ts))

    const quoteAssetBalance = this._getBalance(quoteAsset)
    let maxBuyAmount = this._roundValue(
      parseFloat(quoteAssetBalance) / parseFloat(askValue || latestPrice),
      lotSize
    )
    maxBuyAmount = maxBuyAmount || '0.0'

    const baseAssetBalance = this._getBalance(baseAsset)
    const maxSellAmount = parseFloat(baseAssetBalance) ? parseFloat(baseAssetBalance) : '0.0'

    if (
      (!askValue && !bidValue) ||
      buyAmount !== prevProps.buyAmount ||
      sellAmount !== prevProps.sellAmount ||
      prevProps.currentPrice !== currentPrice ||
      latestTradePair !== prevLatestTradePair
    ) {
      const roundSellAmount = this._roundValue(sellAmount, lotSize)
      const roundBuyAmount = this._roundValue(buyAmount, lotSize)
      let askTotal = buyAmount
        ? this._roundValue(parseFloat(latestPrice, 10) * parseFloat(roundBuyAmount, 10), tickerSize)
        : ''

      askTotal =
        askTotal >= parseFloat(quoteAssetBalance, 10)
          ? this._roundValue(parseFloat(quoteAssetBalance, 10))
          : askTotal

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        askValue: askValue === 'void' ? '' : latestPrice,
        bidValue: bidValue === 'void' ? '' : latestPrice,
        buyAmount: buyAmount === '' ? '' : roundBuyAmount,
        sellAmount: sellAmount === '' ? '' : roundSellAmount,
        maxSellAmount: this._roundValue(maxSellAmount, lotSize),
        maxBuyAmount,
        askTotal,
        bidTotal:
          latestPrice && sellAmount !== ''
            ? this._roundValue(parseFloat(latestPrice, 10) * parseFloat(roundSellAmount, 10))
            : '',
      })
    }

    if (maxBuyAmount !== prevProps.maxBuyAmount || maxSellAmount !== prevProps.maxSellAmount) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ maxSellAmount, maxBuyAmount })
    }
  }

  _checkRoundSize = (roundValue, roundSize) => {
    try {
      roundSize = new Big(roundSize)
      roundValue = new Big(roundValue)
      const roundResult = +roundValue.mod(roundSize).toString()
      return !(roundResult > 0)
    } catch (err) {
      return true
    }
  }

  _checkQuantity = (side, quantity) => {
    const { userInfo, baseAsset, quoteAsset, formatI18nText } = this.props
    const { askTotal } = this.state
    const balances = userInfo.balances || []
    let result = true
    if (side === 1) {
      const availableBalance = balances.find(b => b.symbol === quoteAsset)
      if (!availableBalance || availableBalance.free < parseFloat(askTotal, 10)) {
        this.setState({ buyErrMsg: formatI18nText('exchange.placeOrder.noEnoughBalance') })
        result = false
      }

      if (/.+-[a-zA-Z0-9]{3}m/i.test(baseAsset) && quantity < 1) {
        this.setState({
          buyErrMsg: formatI18nText('exchange.placeOrder.buy.correctAmountForbep8'),
        })
        result = false
      }
    }

    if (side === 2) {
      const baseAssetBalance = balances.find(b => b.symbol === baseAsset)
      if (!baseAssetBalance || baseAssetBalance.free < parseFloat(quantity, 10)) {
        this.setState({ sellErrMsg: formatI18nText('exchange.placeOrder.noEnoughBalance') })
        result = false
      }

      if (
        /.+-[a-zA-Z0-9]{3}m/i.test(baseAsset) &&
        (quantity < 1 || (quantity < 1 && quantity !== baseAssetBalance))
      ) {
        this.setState({
          sellErrMsg: formatI18nText('exchange.placeOrder.sell.correctAmountForbep8'),
        })
        result = false
      }
    }

    return result
  }

  _placeOrder = async (client, wcClient, side, price, quantity, currentTarget) => {
    const {
      address,
      baseAsset,
      quoteAsset,
      privateKey,
      dispatch,
      latestTrade,
      hasPriceChecked,
      tickerSize,
      lotSize,
      history,
      formatI18nText,
      isIpValid,
    } = this.props

    if (!isElectron() && !isIpValid) {
      dispatch(setShowIpValidation(true))
      return
    }

    if (!hasPrivateKey()) {
      history.push('/unlock')
    }

    const latestPrice = latestTrade.p || latestTrade.price

    if (!address) {
      dispatch(setNotLoginNotify(true))
      return
    }

    if (!this._checkQuantity(side, quantity)) {
      return
    }

    if (!this._checkRoundSize(price, tickerSize)) {
      if (side === 1) {
        this.setState({ buyErrMsg: `price should be integer multiples of ${parseFloat(lotSize)}` })
      } else {
        this.setState({ sellErrMsg: `price should be integer multiples of ${parseFloat(lotSize)}` })
      }

      return
    }

    if (!this._checkRoundSize(quantity, lotSize)) {
      if (side === 1) {
        this.setState({
          buyErrMsg: `You can only buy ${baseAsset} in multiples of ${parseFloat(lotSize)}`,
        })
      } else {
        this.setState({
          sellErrMsg: `You can only sell ${baseAsset} in multiples of ${parseFloat(lotSize)}`,
        })
      }

      return
    }

    if (!price || price < 0) {
      if (side === 1) {
        this.setState({ buyErrMsg: formatI18nText('exchange.placeOrder.pleaseInputCorrectPrice') })
      } else {
        this.setState({ sellErrMsg: formatI18nText('exchange.placeOrder.pleaseInputCorrectPrice') })
      }
      return
    }

    this.setState({ buyErrMsg: '', sellErrMsg: '' })

    if (!quantity || quantity < 0) {
      if (side === 1) {
        this.setState({ buyErrMsg: formatI18nText('exchange.placeOrder.pleaseInputCorrectAmount') })
      } else {
        this.setState({
          sellErrMsg: formatI18nText('exchange.placeOrder.pleaseInputCorrectAmount'),
        })
      }
      return
    }

    this.setState({ buyErrMsg: '', sellErrMsg: '' })

    if (isUnlockWithWalletConnect() && !wcClient.connected()) {
      const uri = await wcClient.startSession(false)
      console.log('WalletConnect URI', uri)
      dispatch(setWalletConnectURI(uri))
      dispatch(setTriggerElement(currentTarget))
      return
    }

    if (!privateKey) {
      dispatch(setTriggerElement(currentTarget))
      dispatch(setNeedAuth(true))
      return
    }

    if (price >= latestPrice * 1.02 && !hasPriceChecked && side === 1) {
      const priceNotifyText = formatI18nText('exchange.placeOrder.orderPriceHigher')

      dispatch(setTriggerElement(currentTarget))
      dispatch(setPriceCheckText(priceNotifyText))
      dispatch(setShowPriceNotify(true))
      dispatch(setPriceCheck(true))
      return
    }

    if (price <= latestPrice * 0.98 && !hasPriceChecked && side === 2) {
      const priceNotifyText = formatI18nText('exchange.placeOrder.orderPriceLow')

      dispatch(setTriggerElement(currentTarget))
      dispatch(setPriceCheckText(priceNotifyText))
      dispatch(setShowPriceNotify(true))
      dispatch(setPriceCheck(true))
      return
    }

    const account = (await request.getAccount(address)) || {}

    privateKey !== 'HARDWARE' && (await client.setPrivateKey(privateKey))

    const accCode = crypto.decodeAddress(address)
    const sequence = parseInt(account.sequence, 10)

    const placeOrderMsg = {
      sender: accCode,
      id: `${accCode.toString('hex')}-${sequence + 1}`.toUpperCase(),
      symbol: `${baseAsset}_${quoteAsset}`,
      ordertype: 2,
      side,
      price: this._roundValue(price, tickerSize),
      quantity: this._roundValue(quantity, lotSize),
      timeinforce: 1,
      msgType: 'NewOrderMsg',
    }

    try {
      dispatch(setLoading(true))
      const res = await client.placeOrder(
        address,
        `${baseAsset}_${quoteAsset}`,
        side,
        price,
        quantity,
        sequence
      )
      dispatch(setLoading(false))
      if (res.status === 200) {
        const sideText = side === 1 ? 'Buy' : 'Sell'
        this.setState(
          {
            notifyType: 'success',
            notifyMsg: formatI18nText('exchange.placeOrder.successNotifyMsg', {
              values: {
                side: sideText,
                quantity,
                quoteAsset: baseAsset,
              },
            }),
            notifyTitle: formatI18nText('exchange.placeOrder.successNotifyTitle', {
              values: {
                side: sideText,
              },
            }),
            showNotify: true,
          },
          () => {
            dispatch(setPriceCheck(false))
            this._updateOpenOrders(placeOrderMsg, res.result[0])
          }
        )
      } else {
        this.setState(
          {
            notifyType: 'fail',
            notifyMsg: res.msg || formatI18nText('common.errorOccured'),
            notifyTitle: formatI18nText('exchange.placeOrder.orderError'),
            showNotify: true,
          },
          () => {
            dispatch(setPriceCheck(false))
            dispatch(setLoading(false))
          }
        )
      }
    } catch (err) {
      console.log(err)
      this.setState(
        {
          notifyType: 'fail',
          notifyMsg: err.message || formatI18nText('common.errorOccured'),
          notifyTitle: formatI18nText('exchange.placeOrder.orderError'),
          showNotify: true,
        },
        () => {
          dispatch(setPriceCheck(false))
          dispatch(setLoading(false))
        }
      )
    }
  }

  _buy = (client, wcClient) => ev => {
    const { askValue, buyAmount } = this.state
    this._placeOrder(client, wcClient, 1, askValue, buyAmount, ev.currentTarget)
  }

  _sell = (client, wcClient) => ev => {
    const { bidValue, sellAmount } = this.state
    this._placeOrder(client, wcClient, 2, bidValue, sellAmount, ev.currentTarget)
  }

  _updateOpenOrders = (order, data) => {
    const { openOrders, dispatch } = this.props
    openOrders.unshift({
      transactionHash: data.hash,
      orderCreateTime: new Date(),
      symbol: order.symbol,
      side: order.side,
      price: order.price,
      quantity: order.quantity,
      cumulateQuantity: 0,
      total: order.price * order.quantity,
      op: '',
      orderId: order.id,
    })

    dispatch(setOpenOrder({ order: openOrders }))
  }

  _getBalance = quoteAsset => {
    const { userInfo } = this.props
    const balances = userInfo.balances || []
    for (let i = 0, len = balances.length; i < len; i++) {
      if (quoteAsset === balances[i].symbol) {
        return balances[i].free
      }
    }

    return 0
  }

  _buildAsks = () => {
    const { orderBooks } = this.props
    const result = []
    const asks = orderBooks.asks || []
    for (let len = asks.length - 1; len >= 0; len--) {
      const ask = asks[len]
      result.push({
        price: ask[0],
        amount: ask[1],
        total: ask[0] * ask[1],
        type: 'ask',
      })
    }
    return result
  }

  _buildBids = () => {
    const { orderBooks } = this.props
    const result = []
    const bids = orderBooks.bids || []
    for (let len = bids.length - 1; len >= 0; len--) {
      const bid = bids[len]
      result.push({
        price: bid[0],
        amount: bid[1],
        total: bid[0] * bid[1],
        type: 'bid',
      })
    }
    return result
  }

  _bestAsk = () => {
    const asks = this._buildAsks()
    const bestAsk = asks[asks.length - 1] || {}
    const { tickerSize, lotSize } = this.props
    let { buyAmount, askTotal } = this.state
    const askValue = this._roundValue(bestAsk.price, tickerSize)
    if (!buyAmount && !askTotal) {
      this.setState({ askValue })
      return
    }

    if (askTotal) {
      buyAmount = this._roundValue(askTotal / askValue, lotSize)
    } else {
      askTotal = this._roundValue(buyAmount * askValue, tickerSize)
    }

    this.setState({ askValue, buyAmount, askTotal })
  }

  _bestBid = () => {
    const bids = this._buildBids()
    const bestBid = bids[bids.length - 1] || {}
    const { tickerSize, lotSize } = this.props
    let { sellAmount, bidTotal } = this.state
    const bidValue = this._roundValue(bestBid.price, tickerSize)
    if (!sellAmount && !bidTotal) {
      this.setState({ bidValue })
      return
    }

    if (bidTotal) {
      sellAmount = this._roundValue(bidTotal / bidValue, lotSize)
    } else {
      bidTotal = this._roundValue(sellAmount * bidValue, tickerSize)
    }

    this.setState({ bidValue, sellAmount, bidTotal })
  }

  _calBuyPercentage = percentage => {
    const { askValue } = this.state
    if (!askValue) {
      return
    }
    const { quoteAsset, lotSize } = this.props
    const quoteAssetBalance = this._getBalance(quoteAsset)
    this.setState({
      buyAmount: this._roundValue((quoteAssetBalance * percentage) / askValue, lotSize),
      askTotal: this._roundValue(quoteAssetBalance * percentage),
    })
  }

  _calSellPercentage = percentage => {
    const { bidValue } = this.state
    if (!bidValue) {
      return
    }
    const { baseAsset, lotSize } = this.props
    const baseAssetBalance = this._getBalance(baseAsset)
    const sellAmount = this._roundValue(baseAssetBalance * percentage, lotSize)
    this.setState({
      sellAmount,
      bidTotal: this._roundValue(sellAmount * bidValue),
    })
  }

  _roundValue = (value, precision) => {
    precision = precision || '0.00000001'
    const ts = decimalPlaces(precision)
    value = parseFloat(floor(value, ts), 10)
    return value
  }

  _askValueChange = askValue => {
    const { buyAmount } = this.state
    const { quoteAsset, lotSize } = this.props
    const quoteAssetBalance = this._getBalance(quoteAsset)
    let maxBuyAmount =
      askValue && this._roundValue(parseFloat(quoteAssetBalance) / parseFloat(askValue), lotSize)

    maxBuyAmount = maxBuyAmount || '0.0'
    askValue = askValue === '' || askValue === 0 ? 'void' : askValue

    if (buyAmount) {
      this.setState({
        askValue,
        maxBuyAmount,
        askTotal: askValue
          ? this._roundValue(parseFloat(askValue, 10) * parseFloat(buyAmount, 10))
          : '',
      })
    } else {
      this.setState({ askValue, maxBuyAmount })
    }
  }

  _bidValueChange = bidValue => {
    const { sellAmount } = this.state
    const { baseAsset } = this.props
    const baseAssetBalance = this._getBalance(baseAsset)
    bidValue = bidValue === '' || bidValue === 0 ? 'void' : bidValue
    if (sellAmount) {
      this.setState({
        bidValue,
        maxSellAmount: parseFloat(baseAssetBalance) ? parseFloat(baseAssetBalance) : '0.0',
        bidTotal: bidValue
          ? this._roundValue(parseFloat(bidValue, 10) * parseFloat(sellAmount, 10))
          : '',
      })
    } else {
      this.setState({ bidValue })
    }
  }

  _buyAmountChange = buyAmount => {
    const { askValue } = this.state
    const { quoteAsset, lotSize } = this.props
    const quoteAssetBalance = this._getBalance(quoteAsset)
    const maxBuyAmount = this._roundValue(
      parseFloat(quoteAssetBalance) / parseFloat(askValue),
      lotSize
    )
    if (askValue) {
      this.setState({
        buyAmount,
        maxBuyAmount: maxBuyAmount || '0.0',
        askTotal: buyAmount
          ? this._roundValue(parseFloat(askValue, 10) * parseFloat(buyAmount, 10))
          : '',
      })
    } else {
      this.setState({ buyAmount })
    }
  }

  _sellAmountChange = sellAmount => {
    const { bidValue } = this.state
    const { baseAsset } = this.props
    if (bidValue) {
      const baseAssetBalance = this._getBalance(baseAsset)
      this.setState({
        sellAmount,
        maxSellAmount: parseFloat(baseAssetBalance) ? parseFloat(baseAssetBalance) : '0.0',
        bidTotal: sellAmount
          ? this._roundValue(parseFloat(bidValue, 10) * parseFloat(sellAmount, 10))
          : '',
      })
    } else {
      this.setState({ sellAmount })
    }
  }

  _askTotalChange = askTotal => {
    const { askValue } = this.state
    let { buyAmount } = this.state
    const { lotSize } = this.props
    if (!askValue && !buyAmount) {
      this.setState({ askTotal })
    } else {
      buyAmount = askTotal
        ? this._roundValue(parseFloat(askTotal, 10) / parseFloat(askValue), lotSize)
        : ''

      this.setState({
        askTotal,
        buyAmount,
      })
    }
  }

  _bidTotalChange = bidTotal => {
    const { bidValue, sellAmount } = this.state
    const { lotSize } = this.props
    if (!bidValue && !sellAmount) {
      this.setState({ bidTotal })
    } else {
      this.setState({
        bidTotal,
        sellAmount: bidTotal
          ? this._roundValue(parseFloat(bidTotal, 10) / parseFloat(bidValue, 10), lotSize)
          : '',
      })
    }
  }

  _handleBuyWithMoonpay = async () => {
    const { deviceInfo, address, history } = this.props
    setFingerPrint(deviceInfo, 'place_order_moon_pay', address, '')
    if (!address) {
      history.push('/en/unlock?buyWithMoonpay=true')
    }
  }

  render() {
    const {
      address,
      quoteAsset,
      baseAsset,
      displayBaseAsset,
      displayQuoteAsset,
      latestTrade,
      tickerSize,
      lotSize,
      formatI18nText,
    } = this.props

    const {
      askValue,
      bidValue,
      buyAmount,
      sellAmount,
      askTotal,
      bidTotal,
      notifyMsg,
      notifyTitle,
      notifyType,
      showNotify,
      buyErrMsg,
      sellErrMsg,
      maxSellAmount,
      maxBuyAmount,
    } = this.state

    const quoteAssetBalance = this._getBalance(quoteAsset)
    const baseAssetBalance = this._getBalance(baseAsset)
    let askPrice = askValue || this._roundValue(latestTrade.price, tickerSize)
    let bidPrice = bidValue || this._roundValue(latestTrade.price, tickerSize)
    askPrice = askPrice < 0.000009 ? toNonExponential(askPrice) : askPrice
    bidPrice = bidPrice < 0.000009 ? toNonExponential(bidPrice) : bidPrice

    return (
      <WalletConnectClientConsumer>
        {wcClient => (
          <BNCClientConsumer>
            {bncClient => (
              <Wrapper>
                <Header>
                  <Title>{formatI18nText('exchange.placeOrder.limitOrder')}</Title>
                  <Space />
                  <BuyButtonContainer onClick={this._handleBuyWithMoonpay}>
                    <BuyWithMoonPay
                      size="increased"
                      shape="fit"
                      address={address}
                      disabled={!address}
                    >
                      {formatI18nText('common.buy-crypto-on-ramp')}
                    </BuyWithMoonPay>
                  </BuyButtonContainer>
                </Header>
                <Content>
                  <FormRow>
                    <FormCol>
                      <span className="title">{formatI18nText('exchange.price')}</span>
                      <Best onClick={this._bestAsk}>
                        {formatI18nText('exchange.placeOrder.bestAsk')}
                      </Best>
                    </FormCol>
                    <FormCol>
                      <span className="title">{formatI18nText('exchange.price')}</span>
                      <Best onClick={this._bestBid}>
                        {formatI18nText('exchange.placeOrder.bestBid')}
                      </Best>
                    </FormCol>
                  </FormRow>
                  <FormRow>
                    <FormCol>
                      <FormInput
                        increment={true}
                        unit={displayQuoteAsset}
                        width="190px"
                        onChange={this._askValueChange}
                        step={tickerSize}
                        min={tickerSize}
                        value={askPrice}
                      />
                    </FormCol>
                    <FormCol>
                      <FormInput
                        increment={true}
                        unit={displayQuoteAsset}
                        width="190px"
                        step={tickerSize}
                        min={tickerSize}
                        onChange={this._bidValueChange}
                        value={bidPrice}
                      />
                    </FormCol>
                  </FormRow>
                  <FormRow>
                    <FormCol>
                      <span className="title">{formatI18nText('exchange.amount')}</span>
                      <Percentage>
                        <PercentageItem
                          onClick={() => {
                            this._calBuyPercentage(0.25)
                          }}
                        >
                          <FontNumber value="25%" />
                        </PercentageItem>
                        <PercentageItem
                          onClick={() => {
                            this._calBuyPercentage(0.5)
                          }}
                        >
                          <FontNumber value="50%" />
                        </PercentageItem>
                        <PercentageItem
                          onClick={() => {
                            this._calBuyPercentage(0.75)
                          }}
                        >
                          <FontNumber value="75%" />
                        </PercentageItem>
                        <PercentageItem
                          onClick={() => {
                            this._calBuyPercentage(1)
                          }}
                        >
                          <FontNumber value="100%" />
                        </PercentageItem>
                      </Percentage>
                    </FormCol>
                    <FormCol>
                      <span className="title">{formatI18nText('exchange.amount')}</span>
                      <Percentage>
                        <PercentageItem
                          onClick={() => {
                            this._calSellPercentage(0.25)
                          }}
                        >
                          <FontNumber value="25%" />
                        </PercentageItem>
                        <PercentageItem
                          onClick={() => {
                            this._calSellPercentage(0.5)
                          }}
                        >
                          <FontNumber value="50%" />
                        </PercentageItem>
                        <PercentageItem
                          onClick={() => {
                            this._calSellPercentage(0.75)
                          }}
                        >
                          <FontNumber value="75%" />
                        </PercentageItem>
                        <PercentageItem
                          onClick={() => {
                            this._calSellPercentage(1)
                          }}
                        >
                          <FontNumber value="100%" />
                        </PercentageItem>
                      </Percentage>
                    </FormCol>
                  </FormRow>
                  <FormRow>
                    <FormCol>
                      <FormInput
                        unit={displayBaseAsset}
                        width="inherit"
                        value={buyAmount}
                        maxAmount={maxBuyAmount}
                        placeholder={`${formatI18nText('exchange.max')} ${maxBuyAmount}`}
                        step={lotSize}
                        min={lotSize}
                        onChange={this._buyAmountChange}
                      />
                    </FormCol>
                    <FormCol>
                      <FormInput
                        unit={displayBaseAsset}
                        width="inherit"
                        value={sellAmount}
                        maxAmount={maxSellAmount}
                        placeholder={`${formatI18nText('exchange.max')} ${maxSellAmount}`}
                        step={lotSize}
                        min={lotSize}
                        onChange={this._sellAmountChange}
                      />
                    </FormCol>
                  </FormRow>
                  <FormRow>
                    <FormCol>
                      <span className="title">{formatI18nText('exchange.total')}</span>
                      <span>
                        <FontNumber value={`${quoteAssetBalance} ${displayQuoteAsset} `} />
                      </span>
                    </FormCol>
                    <FormCol>
                      <span className="title">{formatI18nText('exchange.total')}</span>
                      <span>
                        <FontNumber value={`${baseAssetBalance} ${displayBaseAsset} `} />
                      </span>
                    </FormCol>
                  </FormRow>
                  <FormRow>
                    <FormCol>
                      <FormInput
                        unit={displayQuoteAsset}
                        width="inherit"
                        value={askTotal}
                        step={tickerSize}
                        min={tickerSize}
                        onChange={this._askTotalChange}
                      />
                    </FormCol>
                    <FormCol>
                      <FormInput
                        unit={displayQuoteAsset}
                        width="inherit"
                        value={bidTotal}
                        step={tickerSize}
                        min={tickerSize}
                        onChange={this._bidTotalChange}
                      />
                    </FormCol>
                  </FormRow>
                  <FormRow
                    style={{
                      marginTop: '20px',
                    }}
                  >
                    <FormCol>
                      {buyErrMsg && <ErrMsg>{buyErrMsg}</ErrMsg>}
                      <BuyButton onClick={this._buy(bncClient, wcClient)}>
                        <span>{`${formatI18nText('exchange.buy')} ${displayBaseAsset} `}</span>
                      </BuyButton>
                    </FormCol>
                    <FormCol>
                      {sellErrMsg && <ErrMsg>{sellErrMsg}</ErrMsg>}
                      <SellButton onClick={this._sell(bncClient, wcClient)}>
                        <span>{`${formatI18nText('exchange.sell')} ${displayBaseAsset} `}</span>
                      </SellButton>
                    </FormCol>
                  </FormRow>
                </Content>
                {showNotify && (
                  <Notifycation
                    type={notifyType}
                    msg={notifyMsg}
                    title={notifyTitle}
                    close={() => {
                      this.setState({ showNotify: false })
                    }}
                  />
                )}
              </Wrapper>
            )}
          </BNCClientConsumer>
        )}
      </WalletConnectClientConsumer>
    )
  }
}

const mapStateToProps = ({
  account: { privateKey, address, userInfo, cipherPassword },
  exchange: {
    currentTrade,
    currentPrice,
    buyAmount,
    sellAmount,
    hasPriceChecked,
    displayCurrentTrade,
  },
  globalData: { isIpValid, deviceInfo },
  orderBooks,
  tickers: { tickerSize, lotSize },
  order: { openOrders },
  trade: { tradeHistory },
}) => {
  const [baseAsset, quoteAsset] = currentTrade.split('_')
  const [displayBaseAsset, displayQuoteAsset] = displayCurrentTrade.split('_')
  const props = {
    privateKey,
    cipherPassword,
    address,
    quoteAsset,
    baseAsset,
    displayBaseAsset: displayBaseAsset?.replace(/-.+/i, ''),
    displayQuoteAsset: displayQuoteAsset?.replace(/-.+/i, ''),
    latestTrade: tradeHistory.trade[0] || {},
    orderBooks: orderBooks && orderBooks[currentTrade],
    openOrders: openOrders.order,
    userInfo,
    currentPrice,
    buyAmount,
    sellAmount,
    hasPriceChecked,
    isIpValid,
    tickerSize: tickerSize[currentTrade],
    lotSize: lotSize[currentTrade],
    deviceInfo,
  }

  return props
}

export default withI18n(connect(mapStateToProps)(withRouter(PlaceOrder)))
